// Função para renderizar o tooltip personalizado
export const CustomTooltip = ({ active, payload, responsive=false }) => {
    if (active && payload && payload.length) {
        const { name, value, percent } = payload[0].payload;
        return (
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '5px',
                padding: '10px',
                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                fontSize: '12px',
            }}>
                <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
                <p style={{ margin: 0 }}>Total: {value}</p>
                {!responsive && (
                <p style={{ margin: 0 }}>Percentage: {parseFloat(percent).toFixed(2)}%</p>
                )}
            </div>
        );
    }
    return null;
};